module.exports = __webpack_public_path__ + "videos/3d-painting_cn.5dc4ca7.mp4";